// Helpers para o modelo multi-loja (espelho de backend/src/utils/storeAccess.ts):
// profiles.store_name pode ser 'wicomm', 'wicomm,shoulder' ou o sentinela 'multistore'.

export const MULTISTORE = 'multistore'

/** Converte o valor cru de profiles.store_name em lista normalizada (lowercase, sem vazios, sem duplicatas). */
export function parseStoreNames(raw: string | null | undefined): string[] {
  if (!raw) return []
  return [...new Set(raw.split(',').map((s) => s.trim().toLowerCase()).filter(Boolean))]
}

/** Perfil com acesso a todas as lojas (sentinela 'multistore' presente na lista). */
export function isMultiStoreList(stores: string[]): boolean {
  return stores.includes(MULTISTORE)
}

/** O perfil pode acessar a loja? (multistore acessa qualquer uma) */
export function canAccessStore(stores: string[], store: string): boolean {
  const target = store.trim().toLowerCase()
  return isMultiStoreList(stores) || stores.includes(target)
}

/** Perfil que troca de loja em runtime (multistore ou lista com 2+ lojas). */
export function hasStoreChoice(stores: string[] | undefined): boolean {
  if (!stores?.length) return false
  return isMultiStoreList(stores) || stores.length > 1
}
